import { useEffect, useCallback } from "react";

const useKeyboardNavigation = (refs, fieldOrder) => {
  // Function to focus a field by index offset
  const focusField = useCallback(
    (offset) => {
      const currentIndex = fieldOrder.indexOf(
        document.activeElement.getAttribute("name")
      );
      const newIndex =
        (currentIndex + offset + fieldOrder.length) % fieldOrder.length;
      const nextField = fieldOrder[newIndex];
      refs.current[nextField]?.current?.focus();
    },
    [refs, fieldOrder]
  );

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowLeft") {
        focusField(-1);
      } else if (event.key === "ArrowRight") {
        focusField(1);
      } else if (
        event.key === "Enter" &&
        event.location === KeyboardEvent.DOM_KEY_LOCATION_NUMPAD
      ) {
        focusField(event.shiftKey ? -1 : 1);
      } else if (event.key === "Insert") {
        document.getElementById("commodity-owner-form-submit-button")?.click();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [focusField]);

  // Methods to navigate to the next and previous fields
  const moveNext = () => focusField(1);
  const movePrevious = () => focusField(-1);

  refs.current.moveNext = moveNext;
  refs.current.movePrevious = movePrevious;

  // Return these methods so they can be used outside the hook
  return { moveNext, movePrevious };
};

export default useKeyboardNavigation;
